/// <amd-module name="VSSUI/Components/Header/HeaderTitleRow" />
import * as React from "react";

import { IHeaderTitleRowProps } from "./Header.Props";

import { css } from "VSSUI/Util";

export class HeaderTitleRow extends React.Component<IHeaderTitleRowProps> {
    public render() {
        return <div className={css(this.props.className, "bolt-header-title-row flex-row flex-baseline")}>{this.props.children}</div>;
    }
}
